Alpine.data('SevenPaymentMethodSelection', () => ({
    isAllowed(type) {
        if (type?.includes('applePay') && window.ApplePaySession === undefined) {
            return false;
        }

        return true;
    }
}));
